import objectFilter from '@converdy/utils/object-filter'
import splitBreakpoints from '../split-breakpoints'

function parsePadding ({ top, right, bottom, left, unit = 'px' }) {
  return objectFilter(v => Boolean(v) || v === 0)({
    paddingTop: typeof top !== 'undefined' && `${top}${unit}`,
    paddingRight: typeof right !== 'undefined' && `${right}${unit}`,
    paddingBottom: typeof bottom !== 'undefined' && `${bottom}${unit}`,
    paddingLeft: typeof left !== 'undefined' && `${left}${unit}`
  })
}

export default splitBreakpoints(parsePadding)
